import React from 'react';
import styled from 'styled-components';

const SHOP_URL = 'https://jacobscycles.cognipos.com/?category=Watches&q=nuke';

const Page = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1.25rem;
  padding: 2.5rem 1.25rem;
  background: #000;
  color: #fff;
`;

const Mark = styled.img`
  width: min(220px, 70vw);
  height: auto;
`;

const Title = styled.h1`
  font-size: clamp(2rem, 6vw, 3rem);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

const Copy = styled.p`
  max-width: 36rem;
  font-size: 1.125rem;
  line-height: 1.5;
  color: #f2f2f2;
`;

const ShopLink = styled.a`
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.9rem 1.4rem;
  background: #fecb00;
  color: #000;
  font-weight: 700;
  border-radius: 6px;
`;

function App() {
  return (
    <Page>
      <Mark src="/images/g4.png" alt="Nuke Watches" />
      <Title>Nuke watches</Title>
      <Copy>These watches are now sold by Jacobs Cycles.</Copy>
      <ShopLink href={SHOP_URL}>Shop the watches at Jacobs Cycles</ShopLink>
    </Page>
  );
}

export default App;
